module.exports = {"542428100":"普保镇","542428101":"北拉镇","542428102":"佳琼镇","542428103":"德庆镇","542428200":"马前乡","542428201":"门当乡","542428202":"保吉乡","542428203":"青龙乡","542428204":"新吉乡","542428205":"尼玛乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/542428.json
// module id = 2901
// module chunks = 0